// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as FontAwesome$Web from "./FontAwesome.res.js";
import * as Locale$LumiI18n from "lumi-i18n/lib/es6/src/Locale.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function Nav$Button(props) {
  let toString = props.toString;
  let mbClassName = props.className;
  let mbIcon = props.icon;
  let title = props.title;
  let href = Stdlib_Option.map(props.href, mkRef => mkRef(title));
  let hideTitle = Stdlib_Option.getOr(props.hideTitle, false);
  let titleReactString = hideTitle ? null : toString(title);
  return JsxRuntime.jsx("a", {
    children: mbIcon !== undefined ? JsxRuntime.jsxs("span", {
        children: [
          JsxRuntime.jsx("span", {
            children: JsxRuntime.jsx(FontAwesome$Web.Icon.make, {
              variant: Stdlib_Option.getOr(props.iconVariant, "fas"),
              name: mbIcon
            }),
            className: "icon"
          }),
          JsxRuntime.jsx("span", {
            children: titleReactString
          })
        ],
        className: "icon-text"
      }) : titleReactString,
    className: LumiReact.classList([
      [
        Stdlib_Option.getOr(mbClassName, ""),
        Stdlib_Option.isSome(mbClassName)
      ],
      [
        "navbar-item",
        true
      ],
      [
        "is-right",
        Stdlib_Option.getOr(props.isRight, false)
      ],
      [
        "is-active",
        Stdlib_Option.mapOr(props.isActive, false, isActive => isActive(title))
      ]
    ]),
    href: href,
    onClick: props.onClick
  }, toString(title));
}

let Button = {
  make: Nav$Button
};

function Nav$DropDown(props) {
  let children = props.children;
  let mbIcon = props.icon;
  let title = props.title;
  let match = LumiReact.useActive(() => false);
  let toggleDropdown = match.toggle;
  let hideDropdown = match.hide;
  let dropdownIsActive = match.active;
  let match$1 = LumiReact.useActive(() => false);
  let toggleRender = match$1.toggle;
  let titleString = props.toString(title);
  let isRight = Stdlib_Option.getOr(props.isRight, false);
  let closeOnClickMobile = Stdlib_Option.getOr(props.closeOnClickMobile, true);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("a", {
        children: mbIcon !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx("span", {
                children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
                  name: mbIcon
                }),
                className: "icon"
              }),
              JsxRuntime.jsx("span", {
                children: titleString
              })
            ]
          }) : titleString,
        className: LumiReact.classList([
          [
            "navbar-link icon-text is-flex-wrap-nowrap",
            true
          ],
          [
            "is-active",
            Stdlib_Option.mapOr(props.isActive, false, isActive => isActive(title))
          ]
        ]),
        onClick: param => toggleDropdown()
      }),
      JsxRuntime.jsx("div", {
        children: dropdownIsActive ? children : null,
        className: LumiReact.classList([
          [
            "navbar-dropdown is-hidden-desktop",
            true
          ],
          [
            "is-right",
            isRight
          ]
        ]),
        onClick: param => {
          if (closeOnClickMobile) {
            return hideDropdown();
          }
        }
      }),
      JsxRuntime.jsx("div", {
        children: children,
        className: LumiReact.classList([
          [
            "navbar-dropdown is-hidden-touch",
            true
          ],
          [
            "is-right",
            isRight
          ]
        ]),
        onClick: param => {
          hideDropdown();
          toggleRender();
        }
      })
    ],
    className: LumiReact.classList([
      [
        "navbar-item is-hoverable has-dropdown",
        true
      ],
      [
        "is-active",
        dropdownIsActive
      ],
      Stdlib_Option.mapOr(props.className, [
        "",
        false
      ], s => [
        s,
        true
      ])
    ])
  }, titleString + String(match$1.active));
}

let DropDown = {
  make: Nav$DropDown
};

function Make(P) {
  let Nav$Make$Button = props => {
    let locale = Locale$LumiI18n.useContext();
    let toString = x => P.translate(locale, x);
    return JsxRuntime.jsx(Nav$Button, {
      title: props.title,
      icon: props.icon,
      iconVariant: props.iconVariant,
      isActive: props.isActive,
      isRight: props.isRight,
      hideTitle: props.hideTitle,
      className: props.className,
      href: props.href,
      onClick: props.onClick,
      toString: toString
    });
  };
  let Button = {
    make: Nav$Make$Button
  };
  let Nav$Make$DropDown = props => {
    let locale = Locale$LumiI18n.useContext();
    let toString = x => P.translate(locale, x);
    return JsxRuntime.jsx(Nav$DropDown, {
      title: props.title,
      icon: props.icon,
      iconVariant: props.iconVariant,
      isActive: props.isActive,
      isRight: props.isRight,
      hideTitle: props.hideTitle,
      className: props.className,
      children: props.children,
      closeOnClickMobile: props.closeOnClickMobile,
      toString: toString
    });
  };
  let DropDown = {
    make: Nav$Make$DropDown
  };
  return {
    Button: Button,
    DropDown: DropDown
  };
}

export {
  Button,
  DropDown,
  Make,
}
/* LumiReact Not a pure module */
